export default {
	Choose: 'Choisir',
	image: 'une image',
	sound: 'un son',
	video: 'une vidéo',
	file: 'un fichier',
	media: 'un média',
	Reset: 'Redéfinir par défaut',
	map: 'carte',
	noOptions: 'Désolé mais vous ne pouvez utiliser Media form field car vous ne l\'avez pas configurer. Lisez la documentation pour en savoir plus.',
};
